export const isRcsSettingsEligible = (
  customerSegment: string | null | undefined,
  hasRcsSenderApplicationFlag: boolean,
): boolean =>
  hasRcsSenderApplicationFlag ||
  (customerSegment?.toLowerCase().includes('enterprise') ?? false);
